import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'unorm';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import configureStore from './store/configureStore';
// import LogRocket from 'logrocket';
import isTesting from './utilities/isTesting';
import { waitForGlobalConfig } from './utilities/globalConfig';
import { history } from './history';
import CustomRouter from './CustomRouter';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
export let store;

// if (!window.location.hostname.includes('localhost')) {
// DTJ-478 - TODO refactor to new auth
// LogRocket.init('ybxvsi/cas-shield', {
//   network: {
//     requestSanitizer: (request: any) => {
//       // if the url contains login details then 'ignore'
//       const indexOfUsers = request.url.indexOf('users');
//       if (indexOfUsers !== -1) {
//         const urlPath = request.url.substr(indexOfUsers);
//         if (
//           [
//             'auth/signin',
//             'auth/signOut',
//             'auth/forgotPassword',
//             'auth/completeNewPassword',
//             'auth/confirmForgotPassword',
//             'auth/refreshSession'
//           ].includes(urlPath)
//         ) {
//           // ignore the request response pair
//           return null;
//         }
//       }
//       // otherwise log the request normally
//       return request;
//     }
//   }
// });
// }

(async () => {
  const globalConfig = await waitForGlobalConfig();
  store = configureStore();

  if (globalConfig) {
    if (isTesting) {
      // @ts-ignore
      window.__store__ = store;
      // @ts-ignore - Property 'globalConfig' does not exist on type 'Window & typeof globalThis'
      window.globalConfig = {
        apiUrl: 'https://dev-api.cas-staff.net',
        assetsUrl: 'https://dev-customer-artifacts.s3.eu-west-2.amazonaws.com',
        cognitoDomain: '',
        cognitoProviderName: '',
        idpLogout: false,
        myInterviewAPIKey:
          'apikey 8bz12e7yfpw5pokqhalrzyne sig=8aed5921084046ed95eb042f44edfe1582cc1436f75b559ca16d7dac89ddb62d',
        redirectUrl: '',
        samlEnabled: false,
        staffAppClient: '4l39bkg44pjprbml4t2vh80olm',
        staffMFAEnabled: false,
        studentAppClient: '4l39bkg44pjprbml4t2vh80olm',
        studentsMFAEnabled: false,
        uni: 'TST',
        wssUrl: 'wss://ul3yqz8boh.execute-api.eu-west-2.amazonaws.com/prod',
        userpool: 'eu-west-2_wRF3fgulK'
      };
    } else if (
      !(
        window.location.hostname.endsWith('.net') ||
        window.location.hostname.includes('localhost') ||
        window.location.hostname.includes('test-') ||
        window.location.hostname.includes('-int')
      )
    ) {
      Sentry.init({
        environment: 'Production',
        dsn: 'https://d2284fb40b2f42a4953956e8d0723091@o1031975.ingest.sentry.io/5998906',
        ignoreErrors: [
          // Random plugins/extensions
          'top.GLOBALS',
          // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
          'originalCreateNotification',
          'canvas.contentDocument',
          'MyApp_RemoveAllHighlights',
          'http://tt.epicplay.com',
          "Can't find variable: ZiteReader",
          'jigsaw is not defined',
          'ComboSearch is not defined',
          'http://loading.retry.widdit.com/',
          'atomicFindClose',
          // Facebook borked
          'fb_xd_fragment',
          // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
          // reduce this. (thanks @acdha)
          // See http://stackoverflow.com/questions/4113268
          'bmi_SafeAddOnload',
          'EBCallBackMessageReceived',
          // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
          'conduitPage',
          // Generic tawk/twk error pattern
          /twk|tawk/i,
          'googletag',
          "undefined is not an object (evaluating 'a.L')",
          'AxiosError: Network Error'
        ],
        denyUrls: [
          // Facebook flakiness
          /graph\.facebook\.com/i,
          // Facebook blocked
          /connect\.facebook\.net\/en_US\/all\.js/i,
          // Woopra flakiness
          /eatdifferent\.com\.woopra-ns\.com/i,
          /static\.woopra\.com\/js\/woopra\.js/i,
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          /^chrome-extension:\/\//i,
          // Other plugins
          /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
          /webappstoolbarba\.texthelp\.com\//i,
          /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
          /googletagmanager\.com/i,
          /translate\.googleapis\.com/i,
          // Generic tawk.to URL pattern
          /^(?:https?:)?\/\/.*\.?tawk\.to/
        ],
        integrations: [
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: true
          }),
          Sentry.browserTracingIntegration()
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', globalConfig.apiUrl],

        // Capture Replay for 1% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.01,
        replaysOnErrorSampleRate: 1.0
      });
    }
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <CustomRouter history={history}>
        <Provider store={store}>
          <App />
        </Provider>
      </CustomRouter>
    );
  }
})();
